'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'snooze';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f880';
var svgPathData = 'M176 272H24a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h131.19L3.72 469.75A16.06 16.06 0 0 0 0 480v16a16 16 0 0 0 16 16h168a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H36.81l151.48-165.77A15.94 15.94 0 0 0 192 304v-16a16 16 0 0 0-16-16zM272 0H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h78l-98.56 125.2a16.07 16.07 0 0 0-3.44 9.91V176a16 16 0 0 0 16 16h120a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-94l98.56-125.2a16.07 16.07 0 0 0 3.44-9.91V16a16 16 0 0 0-16-16zm176 248.89V240a16 16 0 0 0-16-16H328a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h78l-98.56 125.2a16.07 16.07 0 0 0-3.44 9.91V400a16 16 0 0 0 16 16h120a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-94l98.59-125.2a16.07 16.07 0 0 0 3.41-9.91z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faSnooze = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;